import { DeviceState } from "@/features/audio/types/audio-device.types";
import { BrowserCapabilities } from "@/features/audio/types/browser-capabilities.types";
import { PermissionState } from "@/features/audio/types/permission.types";

export type AudioStoreState = {
    devices: DeviceState;
    permissions: PermissionState;
    capabilities: BrowserCapabilities;
};

type Listener = (state: AudioStoreState) => void;

const defaultPermissions: PermissionState = {
    notifications: "unknown",
    microphone: "unknown",
    speaker: "unknown",
};

const defaultCapabilities: BrowserCapabilities = {
    canSelectMicrophone: false,
    canSelectSpeaker: false,
    supportsOutputRouting: false,
    supportsDeviceEnumeration: false,
    supportsBackgroundAudio: false,
    supportsNotifications: false,
    requiresUserGestureForAudio: false,
};

const defaultDeviceState: DeviceState = {
    inputDeviceId: null,
    outputDeviceId: null,
    devices: [],
    isComplete: false,
};

export class AudioStateStore {
    private state: AudioStoreState = {
        devices: defaultDeviceState,
        permissions: defaultPermissions,
        capabilities: defaultCapabilities,
    };

    private listeners = new Set<Listener>();

    getState(): AudioStoreState {
        return this.state;
    }

    subscribe(listener: Listener): () => void {
        listener(this.state);
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    patch(partial: Partial<AudioStoreState>): void {
        this.state = { ...this.state, ...partial };
        this.listeners.forEach((listener) => listener(this.state));
    }
}
